import * as NavConstants from 'constants/NavConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {Optional} from 'util/Types';

import type {ChatDraftState} from '../ChatDraftState';
import type {InitialUI} from './AISidepanelV2GlobalClientState';

function getClientStateModule(): {
  openExistingChat: (chatSessionId: string) => void;
  openDraftChat: (draftState: ChatDraftState, options: {initialUI?: Optional<InitialUI>}) => void;
} {
  // This avoids a circular dependency in react-render.bundle.js.
  return require('./AISidepanelV2GlobalClientState');
}

export function openChat(chatSessionId: string): void {
  // This avoids a circular dependency in react-render.bundle.js.
  const SidepanelActions = require('nav/sidepanel/SidepanelActions');
  getClientStateModule().openExistingChat(chatSessionId);
  SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
}

export function openDraftChat(
  draftState: ChatDraftState,
  options: {initialUI?: Optional<InitialUI>} = {}
): void {
  getClientStateModule().openDraftChat(draftState, options);
}

export function openDraftChatInSidepanel(agentType: AgentType): void {
  const {makeNewDraftState} = require('../ChatDraftState');
  const SidepanelActions = require('nav/sidepanel/SidepanelActions');
  getClientStateModule().openDraftChat(makeNewDraftState(agentType), {});
  SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
}
